import React from 'react';
import { Text } from 'wix-ui-tpa/Text';
import { classes, st } from './SectionHeader.st.css';
import { AccessibilityHtmlTags } from '../../../../utils/AccessibilityHtmlTags.const';
import { Divider } from 'wix-ui-tpa/Divider';
import { useEnvironment } from '@wix/yoshi-flow-editor';

export type SectionHeaderProps = {
  title: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
  const { isMobile } = useEnvironment();

  return (
    <>
      <Text
        data-hook="section-header-title"
        className={st(classes.title, { isMobile })}
        tagName={AccessibilityHtmlTags.SecondaryHeading}
      >
        {title}
      </Text>
      <Divider className={classes.divider} data-hook="section-header-divider" />
    </>
  );
};

export default SectionHeader;
